import { useState } from 'react';
import { Outlet, useMatch, useParams } from 'react-router-dom';
import { Plus, Search } from 'lucide-react';
import { RenderIf } from '@/components/RenderIf';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import type { ConfigsOutletContext, ConfigsProps } from './types';
import ConfigTypeFilter from './TypeFilter';
import {
    ConfigsContainer,
    ConfigsContent,
    ConfigsHeader,
    HeaderRight,
    SearchContainer,
    SearchIcon,
    ContentContainer,
} from './styled';

function Configs(_props: ConfigsProps) {
    const [shouldOpenCreateModal, setShouldOpenCreateModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const { agentId } = useParams<{ agentId: string }>();
    const isOnListPage = useMatch('/agents/:agentId/configs');

    const outletContext: ConfigsOutletContext = {
        shouldOpenCreateModal,
        setShouldOpenCreateModal,
        searchQuery,
        setSearchQuery,
    };

    return (
        <ConfigsContainer>
            <ConfigsContent>
                <RenderIf isTrue={!!isOnListPage}>
                    <ConfigsHeader>
                        <HeaderRight>
                            <ConfigTypeFilter agentId={agentId!} />
                            <SearchContainer>
                                <SearchIcon>
                                    <Search size={18} />
                                </SearchIcon>
                                <Input
                                    type="text"
                                    placeholder="Search configs..."
                                    value={searchQuery}
                                    onChange={event => setSearchQuery(event.target.value)}
                                />
                            </SearchContainer>
                            <Button onClick={() => setShouldOpenCreateModal(true)}>
                                <Plus className="mr-2 h-4 w-4" />
                                New Config
                            </Button>
                        </HeaderRight>
                    </ConfigsHeader>
                </RenderIf>
                <ContentContainer>
                    <Outlet context={outletContext} />
                </ContentContainer>
            </ConfigsContent>
        </ConfigsContainer>
    );
}

export default Configs;
